var _defs, _defs2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8Cosmetics100(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100px",
    height: "100px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "light-pink-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#ec71ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#876bdb"
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dark-pink-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#ff3ae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#583aff"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#37464e",
    d: "M 59.5,43.5 C 58.1667,43.5 56.8333,43.5 55.5,43.5C 55.5,31.5 55.5,19.5 55.5,7.5C 54.1667,7.5 52.8333,7.5 51.5,7.5C 51.5,19.5 51.5,31.5 51.5,43.5C 50.1667,43.5 48.8333,43.5 47.5,43.5C 44.8333,43.5 42.1667,43.5 39.5,43.5C 39.3334,30.4957 39.5001,17.4957 40,4.5C 46.3333,3.16667 52.6667,3.16667 59,4.5C 59.4999,17.4957 59.6666,30.4957 59.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#536c78",
    d: "M 55.5,43.5 C 54.1667,43.5 52.8333,43.5 51.5,43.5C 51.5,31.5 51.5,19.5 51.5,7.5C 52.8333,7.5 54.1667,7.5 55.5,7.5C 55.5,19.5 55.5,31.5 55.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "url(#light-pink-gradient)",
    d: "M 39.5,43.5 C 42.1667,43.5 44.8333,43.5 47.5,43.5C 48.3775,55.4552 47.0441,67.1219 43.5,78.5C 47.5,78.5 51.5,78.5 55.5,78.5C 51.9559,67.1219 50.6225,55.4552 51.5,43.5C 52.8333,43.5 54.1667,43.5 55.5,43.5C 56.8333,43.5 58.1667,43.5 59.5,43.5C 59.5,44.8333 59.5,46.1667 59.5,47.5C 63.5,47.5 67.5,47.5 71.5,47.5C 72.0614,48.9085 72.3948,50.4085 72.5,52C 71.7891,62.2633 70.6224,72.43 69,82.5C 68.5,83 68,83.5 67.5,84C 55.5,84.6667 43.5,84.6667 31.5,84C 31,83.5 30.5,83 30,82.5C 28.3776,72.43 27.2109,62.2633 26.5,52C 26.6052,50.4085 26.9386,48.9085 27.5,47.5C 31.5,47.5 35.5,47.5 39.5,47.5C 39.5,46.1667 39.5,44.8333 39.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "url(#dark-pink-gradient)",
    d: "M 47.5,43.5 C 48.8333,43.5 50.1667,43.5 51.5,43.5C 50.6225,55.4552 51.9559,67.1219 55.5,78.5C 51.5,78.5 47.5,78.5 43.5,78.5C 47.0441,67.1219 48.3775,55.4552 47.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bcd8f6",
    d: "M 27.5,47.5 C 26.9386,48.9085 26.6052,50.4085 26.5,52C 27.2109,62.2633 28.3776,72.43 30,82.5C 30.5,83 31,83.5 31.5,84C 43.5,84.6667 55.5,84.6667 67.5,84C 68,83.5 68.5,83 69,82.5C 70.6224,72.43 71.7891,62.2633 72.5,52C 72.3948,50.4085 72.0614,48.9085 71.5,47.5C 74.3245,47.0807 76.4912,48.0807 78,50.5C 78.6667,64.1667 78.6667,77.8333 78,91.5C 77.5776,93.4257 76.4109,94.4257 74.5,94.5C 65.8024,92.7112 56.9691,91.7112 48,91.5C 40.0333,91.6192 32.1999,92.6192 24.5,94.5C 22.5891,94.4257 21.4224,93.4257 21,91.5C 20.3333,77.8333 20.3333,64.1667 21,50.5C 22.5088,48.0807 24.6755,47.0807 27.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#92c8f4",
    d: "M 74.5,94.5 C 57.8333,95.8333 41.1667,95.8333 24.5,94.5C 32.1999,92.6192 40.0333,91.6192 48,91.5C 56.9691,91.7112 65.8024,92.7112 74.5,94.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Cosmetics100);
export default __webpack_public_path__ + "static/media/icons8-cosmetics-100.d412818a9910337acafdc24ade86e05f.svg";
export { ForwardRef as ReactComponent };